import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';
import  {deleteData } from '../ApiCalls/DataApis';
import Alert from '@material-ui/lab/Alert';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import IconButton from '@material-ui/core/IconButton';

const styles = theme => ({
  paper: {
    position: 'relative',
    width: theme.spacing(70),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]:{
      width: theme.spacing(60),
    },
    [theme.breakpoints.down('xs')]:{
      width: theme.spacing(43),
    }
  },
  button: {
    width: 'auto',
    height: 'auto',
    padding: '4px',
    margin: '0px',
    border:'0px solid #4f86ce',
    justifyContent: 'flex-end',
    alignItems:'flex-end',
    alignItems: 'flex-end',
    fontFamily:'Trebuchet MS',
    outline: 'none',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  // oldButton: {
  //   backgroundColor:'transparent',
  //   borderRadius:'5px',
  //   border:'1px solid #546e7a',
  //   display:'inline-block',
  //   cursor:'pointer',
  //   color:'#546e7a',
  //   fontFamily:'Trebuchet MS',
  //   fontSize:'10px',
  //   // font-weight:bold;
  //   // height: '34px',
  //   padding:'3px 10px',
  //   textDecoration:'none',
  //   textShadow:'0px 0px 0px #9eb9ff',
  //   outline: 'none',
  //   '&:hover': {
  //     backgroundColor:'transparent',
  //   },
  //   '&:active': {
  //     position:'relative',
  //     top:'1px',
  //     outline: 'none',
  //   },
  //   '&:focus': {
  //     outline: 'none',
  //   },
  // },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fafafa',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dialog: { borderRadius: 10 } ,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class DeleteRemoteConnectionModal extends React.Component {
  state = {
    open: false,
    loading: false,
    success: false,
  };

  timer = undefined;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  handleOpen = () => {
    this.setState({ 
      open: true,
      loading: false,
      success: false });
  };

  handleClose = () => {
    this.setState({ 
      open: false,
      loading: false,
      success: false
    });
  };

  submitButtonClick = () => {
    const { loading } = this.state;
    if (!loading) {
      this.setState(
        {
          success: false,
          loading: true,
        },
        () => {  
        deleteData('https://api.iotflows.com/v1/devices/' + this.props.device_uuid + '/connections',
          {"from_port": this.props.portNumber,
          "from_ip": this.props.from_ip,
          })
          .then(async response => {
            if(response.ok){ 
              // const data = await response.json();
              this.props.showSuccessSnackbar("Remote connection has been successfully removed!");
              this.props.refreshRemoteConnectionList();
              this.setState({
                loading: false,
                success: true,
                open:false,
              });
            }
            else{
              try{
                const data = await response.json();
                this.props.showErrorSnackbar(data.message);
                this.setState({
                  loading: false,
                  success: false,
                  open:false,
                });
              }catch (e){
                this.props.showErrorSnackbar('Something went wrong'); 
              }
            }
          })
        }
      )
    }
  };

  

  render() {
    const { classes } = this.props;
    const { open, loading, success } = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });
    

    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        direction="column"
        
      >
        {/* <Button className={classes.oldButton} variant="contained" onClick={this.handleOpen}>Delete</Button> */}
        <IconButton className={classes.button} variant="outlined" onClick={this.handleOpen}><DeleteOutlineOutlinedIcon style={{color: '#757575'}}/></IconButton>
        
          
          <Dialog
              open={open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              keepMounted
              classes = {{paper: classes.dialog}}
            >
              <Paper className={classes.paper} >
                <DialogTitle style={{paddingBottom: '0px'}} > Delete {this.props.remoteConnectionName} Remote Connection</DialogTitle>
                <DialogContent dividers style={{paddingBottom: '20px', paddingTop: '20px'}}>
                
                  <DialogContentText style={{margin: '0px', marginBottom: '16px'}} >
                    Are you sure you want to delete {this.props.remoteConnectionName} remote connection?
                  </DialogContentText>

                  {/* <Alert severity="warning">
                    Your subscription will be active until the end of the month. Afterward, it will automatically be deleted from your account.
                  </Alert>  */}

                </DialogContent>
                <DialogActions style={{justifyContent:'flex-end'}}>
                  <Button onClick={this.handleClose} >
                    Close
                  </Button>
                  <Button  color="primary" type='submit' className={buttonClassname} disabled={loading} onClick={this.submitButtonClick}>
                    Delete { loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </DialogActions>
              </Paper>
         
        </Dialog>
        
      </Grid>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
  showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),

})
const mapStateToProps = state => {
  return {
    selectedOrganization: state.organizations.selectedOrganization,

  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(DeleteRemoteConnectionModal));
